import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//路由组件
import home from '../pages/home'
import slider from '../pages/slider'
import elist from '../pages/elist'
import detail from '../pages/detail'
import single from '../pages/single'
import aptitude from '../pages/aptitude'
import contactus from '../pages/contactus'
import communication from '../pages/communication'
import specialist from '../pages/specialist'
import specialist_detail from '../pages/specialist_detail'
import branch from '../pages/branch'
import join from '../pages/join'
import column from '../pages/column'
import deliver from '../pages/deliver'

Vue.component('home',home)
Vue.component('slider',slider)
Vue.component('elist',elist)
Vue.component('single',single)
Vue.component('aptitude',aptitude)
Vue.component('contactus',contactus)
Vue.component('communication',communication)
Vue.component('specialist',specialist)
Vue.component('specialist_detail',specialist_detail)
Vue.component('branch',branch)
Vue.component('join',join)
Vue.component('column',column)
Vue.component('deliver',deliver)


//重复路由消除警告
const routerRePush = VueRouter.prototype.push
VueRouter.prototype.push = function (location) {
  return routerRePush.call(this, location).catch(error => error)
}



const router = new VueRouter({
	routes : [
		{ path: '/', component: home },
		{ path: '/detail/:id', component: detail},
		{ 
			path: '/slider/:id', 
			component: slider ,
			children:[
				{ path: 'elist', component: elist },
				{ path: 'single', component: single },
				{ path: 'aptitude', component: aptitude },
				{ path: 'contactus', component: contactus },
				{ path: 'communication', component: communication },
				{ path: 'specialist', component: specialist },
				{ path: 'specialist_detail', component: specialist_detail },
				{ path: 'branch', component: branch },
				{ path: 'join', component: join },
				{ path: 'deliver', component: deliver },

			]
		},
		{ path: '/column', component: column },
		// { path: '/work', component: work },
		// { path: '/special', component: special },
		// { path: '/service', component: service }
	]
})

export default  router